export default {"src":"/_next/static/media/fb.8fb0397b.svg","height":32,"width":32};